document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-slider-dir]');
  if (!button) return;
  var wrap = button.closest('[data-slider-wrap]');
  if (!wrap) return;
  var track = wrap.querySelector('[data-product-track]');
  if (!track) return;
  var direction = button.getAttribute('data-slider-dir') === 'next' ? 1 : -1;
  track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.82), behavior: 'smooth' });
});

(function () {
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('mirlaine_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem('mirlaine_wishlist', JSON.stringify(items));
    } catch (e) {}
  }

  function syncWishlistButtons(handle) {
    if (!handle) return;
    var active = getWishlist().indexOf(handle) !== -1;
    var escapedHandle = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
    document.querySelectorAll('[data-wishlist-button][data-product-handle="' + escapedHandle + '"]').forEach(function (button) {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var text = button.querySelector('[data-wishlist-text]');
      var heart = button.querySelector('.mu-heart');
      if (text) text.textContent = active ? 'Saved' : 'Favorite';
      if (heart) heart.textContent = active ? '♥' : '♡';
      if (!text && button.classList.contains('mu-mobile-heart')) button.textContent = active ? '♥' : '♡';
    });
  }

  function setMainImage(root, source, alt, imageId) {
    if (!root || !source) return;
    var mainImage = root.querySelector('.mu-product-main-image');
    if (!mainImage) return;

    // The original responsive srcset can keep an old image visible after src changes.
    // Remove it whenever the customer actively switches media.
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = source;
    if (alt) mainImage.alt = alt;

    root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      var sameId = imageId && thumb.getAttribute('data-image-id') === String(imageId);
      var sameSource = !imageId && thumb.getAttribute('data-image-src') === source;
      thumb.classList.toggle('is-active', !!(sameId || sameSource));
    });
  }

  function getGalleryImages(root) {
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
    if (thumbs.length) {
      return thumbs.map(function (thumb) {
        return {
          src: thumb.getAttribute('data-image-src'),
          alt: thumb.getAttribute('data-image-alt') || ''
        };
      }).filter(function (item) { return item.src; });
    }
    var main = root.querySelector('.mu-product-main-image');
    return main && main.src ? [{ src: main.src, alt: main.alt || '' }] : [];
  }

  function openLightbox(root) {
    var box = root.querySelector('[data-product-lightbox]');
    var image = box && box.querySelector('[data-lightbox-image]');
    var main = root.querySelector('.mu-product-main-image');
    if (!box || !image || !main) return;

    var images = getGalleryImages(root);
    var currentSrc = main.currentSrc || main.src;
    var index = images.findIndex(function (item) {
      return item.src === main.src || item.src === currentSrc || currentSrc.indexOf(item.src.split('?')[0]) !== -1;
    });
    if (index < 0) index = 0;
    box._muImages = images;
    box._muIndex = index;
    showLightboxImage(box);
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function showLightboxImage(box) {
    var image = box.querySelector('[data-lightbox-image]');
    var images = box._muImages || [];
    if (!image || !images.length) return;
    var index = ((box._muIndex || 0) % images.length + images.length) % images.length;
    box._muIndex = index;
    image.src = images[index].src;
    image.alt = images[index].alt || '';
  }

  function closeLightbox(box) {
    if (!box) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var wishButton = event.target.closest('[data-wishlist-button]');
    if (wishButton) {
      var handle = wishButton.getAttribute('data-product-handle');
      if (!handle) return;
      var items = getWishlist();
      var index = items.indexOf(handle);
      if (index === -1) items.push(handle);
      else items.splice(index, 1);
      saveWishlist(items);
      syncWishlistButtons(handle);
      return;
    }

    var thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      var thumbRoot = thumb.closest('[data-product-root]');
      if (!thumbRoot) return;
      setMainImage(
        thumbRoot,
        thumb.getAttribute('data-image-src'),
        thumb.getAttribute('data-image-alt'),
        thumb.getAttribute('data-image-id')
      );
      return;
    }

    var zoom = event.target.closest('[data-product-zoom]');
    if (zoom) {
      var zoomRoot = zoom.closest('[data-product-root]');
      if (zoomRoot) openLightbox(zoomRoot);
      return;
    }

    var close = event.target.closest('[data-lightbox-close]');
    if (close) {
      closeLightbox(close.closest('[data-product-lightbox]'));
      return;
    }

    var prev = event.target.closest('[data-lightbox-prev]');
    var next = event.target.closest('[data-lightbox-next]');
    if (prev || next) {
      var box = event.target.closest('[data-product-lightbox]');
      if (!box) return;
      box._muIndex = (box._muIndex || 0) + (next ? 1 : -1);
      showLightboxImage(box);
      return;
    }

    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var control = event.target.closest('[data-qty-control]');
      var input = control && control.querySelector('[data-qty-input]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, value + (plus ? 1 : -1));
      return;
    }

    var cartMinus = event.target.closest('[data-cart-minus]');
    var cartPlus = event.target.closest('[data-cart-plus]');
    if (cartMinus || cartPlus) {
      var cartControl = event.target.closest('[data-cart-qty]');
      var cartInput = cartControl && cartControl.querySelector('[data-cart-qty-input]');
      if (!cartInput) return;
      var cartValue = parseInt(cartInput.value, 10) || 0;
      cartInput.value = Math.max(0, cartValue + (cartPlus ? 1 : -1));
      return;
    }

    var stickyAdd = event.target.closest('[data-sticky-add]');
    if (stickyAdd) {
      var productRoot = stickyAdd.closest('[data-product-root]');
      var mainAdd = productRoot && productRoot.querySelector('[data-add-to-cart]');
      if (mainAdd && !mainAdd.disabled) mainAdd.click();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-product-lightbox].is-open').forEach(closeLightbox);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-select]');
    if (!select) return;
    var root = select.closest('[data-product-root]');
    if (!root) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = option.getAttribute('data-price') || '';
    var compare = option.getAttribute('data-compare') || '';
    var saving = option.getAttribute('data-saving') || '';
    var available = option.getAttribute('data-available') === 'true';
    var image = option.getAttribute('data-image') || '';
    var imageId = option.getAttribute('data-image-id') || '';

    var priceEl = root.querySelector('[data-product-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var compareEl = root.querySelector('[data-product-compare]');
    var status = root.querySelector('[data-product-status]');
    var statusText = root.querySelector('[data-product-status-text]');
    var add = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var stickyText = root.querySelector('[data-sticky-add-text]');
    var buyNow = root.querySelector('[data-buy-now]');
    var saleBadge = root.querySelector('[data-sale-badge]');

    if (priceEl) priceEl.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (compareEl) {
      compareEl.textContent = compare;
      compareEl.classList.toggle('is-hidden', !compare);
    }
    if (status) status.classList.toggle('is-sold-out', !available);
    if (statusText) statusText.textContent = available ? 'In stock' : 'Sold out';
    if (add) add.disabled = !available;
    if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
    if (stickyAdd) stickyAdd.disabled = !available;
    if (stickyText) stickyText.textContent = available ? 'Add to cart' : 'Sold out';
    if (buyNow) buyNow.classList.toggle('is-hidden', !available);
    if (saleBadge) {
      saleBadge.textContent = saving ? 'Save ' + saving : '';
      saleBadge.classList.toggle('is-hidden', !saving);
    }
    if (image) setMainImage(root, image, '', imageId);

    if (window.history && window.history.replaceState && option.value) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }
  });

  document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
    syncWishlistButtons(button.getAttribute('data-product-handle'));
  });
})();

/* Country / region selector */
document.addEventListener('change', function (event) {
  var selector = event.target.closest('[data-country-selector]');
  if (!selector || !selector.form) return;
  selector.form.submit();
});

/* Product recommendations */
document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
  var url = section.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function (response) {
      if (!response.ok) throw new Error('Recommendation request failed');
      return response.text();
    })
    .then(function (html) {
      var container = document.createElement('div');
      container.innerHTML = html;
      var incoming = container.querySelector('[data-product-recommendations]');
      if (!incoming || !incoming.innerHTML.trim()) return;
      section.innerHTML = incoming.innerHTML;
    })
    .catch(function () {});
});

/* Mobile menu quality-of-life */
document.addEventListener('click', function (event) {
  var mobileMenuClose = event.target.closest('[data-mobile-menu-close]');
  if (mobileMenuClose) {
    var parentMenu = mobileMenuClose.closest('.mu-mobile-nav');
    if (parentMenu) parentMenu.removeAttribute('open');
    return;
  }
  document.querySelectorAll('.mu-mobile-nav[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mu-mobile-nav[open]').forEach(function (menu) {
    menu.removeAttribute('open');
  });
});

/* Predictive product search */
(function () {
  var form = document.querySelector('[data-predictive-search]');
  if (!form || form.getAttribute('data-predictive-enabled') !== 'true') return;

  var input = form.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  var endpoint = form.getAttribute('data-predictive-url');
  var timer;
  var request;

  if (!input || !results || !endpoint) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function moneyFromDecimal(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return escapeHtml(value);
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function closeResults() {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function renderProducts(products, query) {
    if (!products.length) {
      results.innerHTML =
        '<div class="mu-predictive-empty"><strong>No matching products yet.</strong>' +
        '<a href="' + escapeHtml(form.action) + '?q=' + encodeURIComponent(query) + '&type=product">Search the full store →</a></div>';
    } else {
      var cards = products.map(function (product) {
        var image = product.featured_image && product.featured_image.url
          ? product.featured_image.url
          : product.image || '';
        return (
          '<a class="mu-predictive-item" href="' + escapeHtml(product.url) + '">' +
            '<span class="mu-predictive-item__image">' +
              (image ? '<img src="' + escapeHtml(image + (image.indexOf('?') === -1 ? '?width=180' : '&width=180')) + '" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="mu-predictive-item__copy">' +
              '<strong>' + escapeHtml(product.title) + '</strong>' +
              '<small>' + moneyFromDecimal(product.price) + '</small>' +
            '</span>' +
          '</a>'
        );
      }).join('');
      results.innerHTML =
        '<div class="mu-predictive-title">Suggested products</div>' +
        '<div class="mu-predictive-list">' + cards + '</div>' +
        '<a class="mu-predictive-all" href="' + escapeHtml(form.action) + '?q=' + encodeURIComponent(query) + '&type=product">View all search results →</a>';
    }
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function search(query) {
    if (request) request.abort();
    request = typeof AbortController !== 'undefined' ? new AbortController() : null;
    results.hidden = false;
    results.innerHTML = '<div class="mu-predictive-loading">Searching…</div>';
    input.setAttribute('aria-expanded', 'true');

    var url = endpoint +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url, request ? { signal: request.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) {
        var products = data && data.resources && data.resources.results
          ? data.resources.results.products || []
          : [];
        renderProducts(products, query);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        closeResults();
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var query = input.value.trim();
    if (query.length < 2) {
      closeResults();
      return;
    }
    timer = setTimeout(function () { search(query); }, 220);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeResults();
  });

  document.addEventListener('click', function (event) {
    if (!form.contains(event.target) && !results.contains(event.target)) closeResults();
  });
})();

/* Ajax quick add and cart drawer */
(function () {
  var shell = document.querySelector('[data-cart-drawer]');
  if (!shell || shell.getAttribute('data-enabled') !== 'true') return;

  var drawer = shell.querySelector('.mu-cart-drawer');
  var itemsContainer = shell.querySelector('[data-cart-drawer-items]');
  var footer = shell.querySelector('[data-cart-drawer-footer]');
  var subtotal = shell.querySelector('[data-cart-drawer-subtotal]');
  var toast = shell.querySelector('[data-cart-toast]');
  var cartUrl = shell.getAttribute('data-cart-url');
  var addUrl = shell.getAttribute('data-add-url');
  var changeUrl = shell.getAttribute('data-change-url');
  var shopUrl = shell.getAttribute('data-shop-url') || '/collections/all';
  var goalCents = Number(shell.getAttribute('data-goal-cents')) || 0;
  var lastTrigger;
  var toastTimer;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + (currency || '');
    }
  }

  function imageUrl(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?width=180' : '&width=180');
  }

  function showToast(message, isError) {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }

  function openDrawer(trigger) {
    lastTrigger = trigger || document.activeElement;
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (drawer) drawer.focus();
  }

  function closeDrawer() {
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-product-lightbox].is-open')) document.documentElement.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function updateGoal(cart) {
    var goal = shell.querySelector('[data-cart-goal]');
    if (!goal || goalCents <= 0) return;
    var remaining = goalCents - cart.total_price;
    var text = goal.querySelector('[data-cart-goal-text]');
    var bar = goal.querySelector('[data-cart-goal-bar]');
    if (text) {
      text.textContent = remaining > 0
        ? 'Add ' + formatMoney(remaining, cart.currency) + ' more to reach free shipping.'
        : 'You reached the free shipping goal.';
    }
    if (bar) bar.style.width = Math.min(100, Math.max(0, cart.total_price / goalCents * 100)) + '%';
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });
    var drawerCount = shell.querySelector('[data-cart-drawer-count]');
    if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    if (footer) footer.classList.toggle('is-hidden', cart.item_count === 0);
    updateGoal(cart);

    if (!itemsContainer) return;
    if (!cart.items.length) {
      itemsContainer.innerHTML =
        '<div class="mu-cart-drawer__empty">' +
          '<span aria-hidden="true">🛍️</span>' +
          '<h3>Your cart is ready for something good.</h3>' +
          '<p>Browse popular fashion, beauty, home and tech finds.</p>' +
          '<a class="button" href="' + escapeHtml(shopUrl) + '">Start shopping</a>' +
        '</div>';
      return;
    }

    itemsContainer.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<small>' + escapeHtml(item.variant_title) + '</small>'
        : '';
      var image = item.image
        ? '<img src="' + escapeHtml(imageUrl(item.image)) + '" alt="" loading="lazy">'
        : '';
      return (
        '<article class="mu-cart-drawer-item" data-cart-line="' + escapeHtml(item.key) + '">' +
          '<a class="mu-cart-drawer-item__image" href="' + escapeHtml(item.url) + '">' + image + '</a>' +
          '<div class="mu-cart-drawer-item__content">' +
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<strong>' + formatMoney(item.final_line_price, cart.currency) + '</strong>' +
            '<div class="mu-cart-drawer-item__actions">' +
              '<div class="mu-cart-drawer-qty">' +
                '<button type="button" data-cart-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-cart-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="mu-cart-drawer-remove" type="button" data-cart-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="0">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (opener) {
      event.preventDefault();
      fetchCart().then(function () { openDrawer(opener); }).catch(function () { window.location.href = opener.href; });
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    var change = event.target.closest('[data-cart-change]');
    if (!change || !shell.contains(change)) return;
    change.disabled = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: change.getAttribute('data-line-key'),
        quantity: Math.max(0, Number(change.getAttribute('data-quantity')) || 0)
      })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw new Error(error.description || 'Cart update failed'); });
        return response.json();
      })
      .then(renderCart)
      .catch(function (error) {
        showToast(error.message || 'The cart could not be updated.', true);
        change.disabled = false;
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-add]');
    if (!form) return;
    if (form.classList.contains('mu-product-form') && event.submitter !== form.querySelector('[data-add-to-cart]')) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var buttonText = button && button.querySelector('span');
    var originalText = buttonText ? buttonText.textContent : button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    if (buttonText) buttonText.textContent = 'Adding…';

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw new Error(error.description || 'This item could not be added.'); });
        return response.json();
      })
      .then(function () { return fetchCart(); })
      .then(function () {
        openDrawer(button);
        showToast('Added to your cart.', false);
      })
      .catch(function (error) {
        showToast(error.message || 'This item could not be added.', true);
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
        if (buttonText) buttonText.textContent = originalText;
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && shell.classList.contains('is-open')) {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab' || !shell.classList.contains('is-open') || !drawer) return;
    var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* Recently viewed products */
(function () {
  var storageKey = 'mirlaine_recently_viewed_v2';
  var productData = document.querySelector('[data-recent-product]');

  function getItems() {
    try {
      var items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    try { localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 12))); } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  if (productData) {
    try {
      var current = JSON.parse(productData.textContent);
      var stored = getItems().filter(function (item) { return String(item.id) !== String(current.id); });
      stored.unshift(current);
      saveItems(stored);
    } catch (error) {}
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var track = section.querySelector('[data-recently-viewed-track]');
    var clear = section.querySelector('[data-recently-clear]');
    var limit = Number(section.getAttribute('data-limit')) || 6;
    var items = getItems().filter(function (item) {
      return item && item.url && window.location.pathname !== item.url;
    }).slice(0, limit);

    if (!track || !items.length) {
      section.classList.add('is-empty');
      return;
    }

    track.innerHTML = items.map(function (item) {
      var compare = Number(item.compareAt || 0) > Number(item.price || 0)
        ? '<s>' + money(item.compareAt, item.currency) + '</s>'
        : '';
      return (
        '<article class="mu-recent-card">' +
          '<a class="mu-recent-card__image" href="' + escapeHtml(item.url) + '">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
          '<p><strong>' + money(item.price, item.currency) + '</strong>' + compare + '</p></div>' +
        '</article>'
      );
    }).join('');

    if (clear) {
      clear.addEventListener('click', function () {
        try { localStorage.removeItem(storageKey); } catch (error) {}
        section.classList.add('is-empty');
        track.innerHTML = '';
      });
    }
  });
})();

/* Mobile dock and desktop dropdown behavior */
document.addEventListener('click', function (event) {
  var searchButton = event.target.closest('[data-mobile-search]');
  if (searchButton) {
    var searchInput = document.querySelector('[data-predictive-input]');
    if (searchInput) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () { searchInput.focus(); }, 250);
    }
  }

  document.querySelectorAll('.mu-category-menu[open], .mu-nav-dropdown[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mu-category-menu[open], .mu-nav-dropdown[open]').forEach(function (menu) {
    menu.removeAttribute('open');
  });
});

/* Load alternate card imagery only when a pointer requests it. */
document.addEventListener('pointerover', function (event) {
  if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
  var card = event.target.closest('.mu-product-card');
  if (!card || card.classList.contains('has-second-loaded')) return;
  var image = card.querySelector('[data-card-second-image]');
  if (!image) return;
  var source = image.getAttribute('data-src');
  if (!source) return;
  image.addEventListener('load', function () { card.classList.add('has-second-loaded'); }, { once: true });
  image.src = source;
  image.removeAttribute('data-src');
});


/* Mirlaine Univers install prompt */
(function(){
 var promptEvent=null,b=document.querySelector('[data-pwa-install]');if(!b)return;
 var btn=b.querySelector('[data-pwa-install-button]'),x=b.querySelector('[data-pwa-install-close]'),t=b.querySelector('[data-pwa-install-text]');
 function installed(){return matchMedia('(display-mode: standalone)').matches||navigator.standalone===true}
 function dismissed(){try{return sessionStorage.getItem('mu_pwa_dismissed')==='1'}catch(e){return false}}
 function show(){if(!installed()&&!dismissed())b.hidden=false} function hide(){b.hidden=true}
 addEventListener('beforeinstallprompt',function(e){e.preventDefault();promptEvent=e;t.textContent='Shop faster from your home screen.';btn.textContent='Install App';show()});
 btn.addEventListener('click',async function(){
   if(promptEvent){promptEvent.prompt();try{await promptEvent.userChoice}catch(e){}promptEvent=null;hide();return}
   if(btn.dataset.help==='1'){hide();return}
   t.textContent='Open the Chrome menu and choose “Add to Home screen” or “Install app”.';btn.textContent='Got it';btn.dataset.help='1'
 });
 x.addEventListener('click',function(){try{sessionStorage.setItem('mu_pwa_dismissed','1')}catch(e){}hide()});
 addEventListener('appinstalled',hide);
 setTimeout(function(){if(/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)&&!installed()&&!dismissed()&&!promptEvent){t.textContent='Add Mirlaine Univers to your home screen for quicker access.';btn.textContent='How to install';show()}},3500);
})();
